"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ISimulationStratagemSchema = exports.TransientSimulationStratagemSchema = exports.OperatingPointSimulationStratagemSchema = exports.ISimulationStratagemBaseSchema = void 0;
const zod_1 = require("zod");
const SpiceDefinitions_1 = require("./SpiceDefinitions");
exports.ISimulationStratagemBaseSchema = zod_1.default.object({
    analysisType: SpiceDefinitions_1.SpiceAnalysisTypeSchema,
    opts: zod_1.default.object({}).passthrough(),
    description: zod_1.default.string().optional(),
});
exports.OperatingPointSimulationStratagemSchema = exports.ISimulationStratagemBaseSchema.extend({
    analysisType: zod_1.default.literal(SpiceDefinitions_1.SpiceAnalysisType.OperatingPoint),
    opts: zod_1.default.object({}).passthrough(),
});
exports.TransientSimulationStratagemSchema = exports.ISimulationStratagemBaseSchema.extend({
    analysisType: zod_1.default.literal(SpiceDefinitions_1.SpiceAnalysisType.Transient),
    opts: zod_1.default.object({}).passthrough(),
});
exports.ISimulationStratagemSchema = zod_1.default.discriminatedUnion('analysisType', [
    exports.OperatingPointSimulationStratagemSchema,
    exports.TransientSimulationStratagemSchema,
]);
//# sourceMappingURL=ISimulationStratagem.js.map